var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.92444 11.8133C7.27111 12.16 7.83111 12.16 8.17778 11.8133L11.3689 8.62222C11.7156 8.27556 11.7156 7.71556 11.3689 7.36889L8.17778 4.17778C7.83111 3.83111 7.27111 3.83111 6.92444 4.17778C6.57778 4.52444 6.57778 5.08444 6.92444 5.43111L8.59556 7.11111H0.888889C0.4 7.11111 0 7.51111 0 8C0 8.48889 0.4 8.88889 0.888889 8.88889H8.59556L6.92444 10.56C6.57778 10.9067 6.58667 11.4756 6.92444 11.8133ZM14.2222 0H1.77778C0.791111 0 0 0.8 0 1.77778V4.44444C0 4.93333 0.4 5.33333 0.888889 5.33333C1.37778 5.33333 1.77778 4.93333 1.77778 4.44444V2.66667C1.77778 2.17778 2.17778 1.77778 2.66667 1.77778H13.3333C13.8222 1.77778 14.2222 2.17778 14.2222 2.66667V13.3333C14.2222 13.8222 13.8222 14.2222 13.3333 14.2222H2.66667C2.17778 14.2222 1.77778 13.8222 1.77778 13.3333V11.5556C1.77778 11.0667 1.37778 10.6667 0.888889 10.6667C0.4 10.6667 0 11.0667 0 11.5556V14.2222C0 15.2 0.8 16 1.77778 16H14.2222C15.2 16 16 15.2 16 14.2222V1.77778C16 0.8 15.2 0 14.2222 0Z",
    fill: "#0769da"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign-out.39b31180055610561109e8d5c1a0e88f.svg";
export { ForwardRef as ReactComponent };